import {
  Category,
  Subtype,
  Type,
} from '@src/main/modules/parameters/domain/issues/category.interface';

export interface CreateCategoryRequest {
  title: string;
  description: string;
  visibleOnApp: boolean;
  typeTitle: string;
  typeVisibleOnApp: boolean;
}

export interface UpdateCategoryRequest {
  title: string;
  description: string;
  visibleOnApp: boolean;
}

export interface CreateTypeRequest {
  title: string;
  category: string;
  visibleOnApp: boolean;
}

export interface UpdateTypeRequest {
  typeId: string;
  title: string;
  category: string;
  visibleOnApp: boolean;
}

export interface CreateSubtypeRequest {
  title: string;
  type: string;
  visibleOnApp: boolean;
}

export interface UpdateSubtypeRequest {
  subtypeId: string;
  title: string;
  type?: string;
  visibleOnApp: boolean;
}

export const toCreateCategoryRequest = (
  category: Category,
  typeTitle: string,
  typeVisibleOnApp: boolean,
): CreateCategoryRequest => ({
  title: category.title,
  description: category.description,
  visibleOnApp: category.visibleOnApp,
  typeTitle,
  typeVisibleOnApp,
});

export const toUpdateCategoryRequest = (category: Category): UpdateCategoryRequest => ({
  title: category.title,
  description: category.description,
  visibleOnApp: category.visibleOnApp,
});

export const toCreateTypeRequest = (type: Type, categoryId: string): CreateTypeRequest => ({
  title: type.title,
  category: categoryId,
  visibleOnApp: type.visibleOnApp,
});

export const toUpdateTypeRequest = (type: Type, categoryId: string): UpdateTypeRequest => ({
  typeId: type.typeId || '',
  title: type.title,
  category: categoryId,
  visibleOnApp: type.visibleOnApp,
});

export const toCreateSubtypeRequest = (subtype: Subtype, typeId: string): CreateSubtypeRequest => ({
  title: subtype.title,
  type: typeId,
  visibleOnApp: subtype.visibleOnApp,
});

export const toUpdateSubtypeRequest = (
  subtype: Subtype,
  typeId?: string,
): UpdateSubtypeRequest => ({
  subtypeId: subtype.subtypeId || '',
  title: subtype.title,
  type: typeId,
  visibleOnApp: subtype.visibleOnApp,
});
